export interface AdminUserInfo {
    imagingCenterName?: any;
    facilityId?: any;
    adminFirstName?: any;
    adminLastName?: any;
    adminUserName?: any;
    adminEmailId?: any;
    adminPhone?: any;
    password?: any;
    confirmPassword?: any;
    MFA?: boolean;
    countryCode?: any

}

export const INITIAL_ADMIN_USER_STATE: AdminUserInfo = {
    imagingCenterName: '',
    facilityId: '',
    adminFirstName: '',
    adminLastName: '',
    adminUserName: '',
    adminEmailId: '',
    adminPhone: '',
    password: '',
    confirmPassword: '',
    countryCode: '',
    MFA: true,

}

export interface ResetPassword {

    adminEmailId?: any;
    verificationCode?: any;
    password?: any;
}

export const INITIAL_RESETPASSWORD_STATE: ResetPassword = {

    adminEmailId: '',
    verificationCode: '',
    password: ''
}

export interface ResendCodeInfo {
    adminUserName?: any;
    loginFrom?: any;
    password?: any;
}

export const INITIAL_RESENDCODE_STATE: ResendCodeInfo = {
    adminUserName: '',
    loginFrom: '',
    password: ''
}

export interface LoggedUserDetails {
    userName: any;
    preferredUserName: any;
    userRole: any;
    admin: any;
    createdBy: any;
    updatedby: any;
    userStatus: any;
    createdDate: any;
    updatedDate: any;
    userFirstName: any;
    userLastName: any;
    userEmail: any;
    userPhone: any;
    profileImageUrl: any;
    linkedFacilityId: any;
    linkedFacilityName: any;
}

export class PopupCancelData {
    displayUploadFile: boolean;
    displaySiteModal: boolean;
    displaySurgeonModal: boolean;
    displayApplicationModal: boolean;
    displaySelectFilesModal: boolean;
}
export class CaseHistoryData {
    page: number;
    limit: number;
    column: any;
    sortOrder: string;
    searchText: string;
    anatomy: any;
    sourceFacilityId: any;
    caseStatus: any;
    claimantUserName: any;
    imagingType: any;
    fromDueDate: any;
    toDueDate: any;
    fromUpdatedDate: any;
    toUpdatedDate: any
}
export class settingsResponse {
    responseStatus: string;
    responseMessage: string;
}

export class errorResponse {
    timeStamp: string;
    errorCode: string;
    errors: [];
}
export class HILCaseDetails {
    createdDateTime: any;
    applicationName: string;
    anatomy: any;
    imagingType: string;
    claimantFirstName: string;
    claimantLastName: string;
    updatedDateTime: any;
    errorNotes: string;
    caseType: string;
}
export class IMGCenterDetails {
    facilityName: string;
    address: string
    city: string;
    state: string;
    zipCode: string;
    facilityContactLead: string;
    facilityEmail: string;
    facilityPhone: any;
}
export class SnnFacilityData {
    snnManager: boolean;
    facilityId: number;
}
export class AuditLogExportData {
    date: any;
    caseId: string;
    userName: string;
    user: string;
    action: string;
    eventOutCome: boolean;
    eventType: string;
}
export class AuditLogExportDate {
    date: Date;
    user: string;
    username: string;
    action: string;
}
